import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Map = Loadable({
  loader: () => import("./routes/map"),
  loading: TopBarProgress,
});
const Monitoring = Loadable({
  loader: () => import("./routes/monitoring"),
  loading: TopBarProgress,
});
const Parcels = Loadable({
  loader: () => import("./routes/nationals/parcels"),
  loading: TopBarProgress,
});
const OverWeight = Loadable({
  loader: () => import("./routes/nationals/overweight"),
  loading: TopBarProgress,
});
const DriverActive = Loadable({
  loader: () => import("./routes/drivers/active"),
  loading: TopBarProgress,
});
const DriverRemoved = Loadable({
  loader: () => import("./routes/drivers/removed"),
  loading: TopBarProgress,
});
const DriverSupsension = Loadable({
  loader: () => import("./routes/drivers/suspension"),
  loading: TopBarProgress,
});

const DriverDocuments = Loadable({
  loader: () => import("./routes/drivers/documents"),
  loading: TopBarProgress,
});
const DriverSafety = Loadable({
  loader: () => import("./routes/drivers/safety"),
  loading: TopBarProgress,
});
const DriverMap = Loadable({
  loader: () => import("./routes/drivers/map"),
  loading: TopBarProgress,
});
const DriverReferences = Loadable({
  loader: () => import("./routes/drivers/references"),
  loading: TopBarProgress,
});

const DriverPermissions = Loadable({
  loader: () => import("./routes/drivers/permissions"),
  loading: TopBarProgress,
});
const VehiclesRequests = Loadable({
  loader: () => import("./routes/vehicles/requests"),
  loading: TopBarProgress,
});
const VehiclesActive = Loadable({
  loader: () => import("./routes/vehicles/active"),
  loading: TopBarProgress,
});
const VehiclesStatus = Loadable({
  loader: () => import("./routes/vehicles/status"),
  loading: TopBarProgress,
});
const Clients = Loadable({
  loader: () => import("./routes/clients"),
  loading: TopBarProgress,
});
const Offers = Loadable({
  loader: () => import("./routes/leads/offers"),
  loading: TopBarProgress,
});
const Requests = Loadable({
  loader: () => import("./routes/leads/requests"),
  loading: TopBarProgress,
});
const Support = Loadable({
  loader: () => import("./routes/leads/support"),
  loading: TopBarProgress,
});
const Preregister = Loadable({
  loader: () => import("./routes/leads/preregister"),
  loading: TopBarProgress,
});

const ServiceHistory = Loadable({
  loader: () => import("./routes/services/history"),
  loading: TopBarProgress,
});
const ServiceValidation = Loadable({
  loader: () => import("./routes/services/validation"),
  loading: TopBarProgress,
});
const ServiceWeekly = Loadable({
  loader: () => import("./routes/services/weekly"),
  loading: TopBarProgress,
});
const ServiceDrivers = Loadable({
  loader: () => import("./routes/services/drivers"),
  loading: TopBarProgress,
});
const Payments = Loadable({
  loader: () => import("./routes/services/payments"),
  loading: TopBarProgress,
});
const Rides = Loadable({
  loader: () => import("./routes/services/rides"),
  loading: TopBarProgress,
});
const Users = Loadable({
  loader: () => import("./routes/catalogs/users"),
  loading: TopBarProgress,
});
const FourTrackError = Loadable({
  loader: () => import("./routes/catalogs/fourTrack-errors"),
  loading: TopBarProgress,
});
const Bindings = Loadable({
  loader: () => import("./routes/catalogs/bindings"),
  loading: TopBarProgress,
});

const Gasoline = Loadable({
  loader: () => import("./routes/catalogs/gasoline"),
  loading: TopBarProgress,
});
const Zones = Loadable({
  loader: () => import("./routes/catalogs/zones"),
  loading: TopBarProgress,
});
const Alerts = Loadable({
  loader: () => import("./routes/catalogs/alerts"),
  loading: TopBarProgress,
});
const Origins = Loadable({
  loader: () => import("./routes/catalogs/origins"),
  loading: TopBarProgress,
});
const MonitorUser = Loadable({
  loader: () => import("./routes/catalogs/monitor"),
  loading: TopBarProgress,
});
const Cordinator = Loadable({
  loader: () => import("./routes/catalogs/cordinator"),
  loading: TopBarProgress,
});
const Lastmile = Loadable({
  loader: () => import("./routes/catalogs/lastmile"),
  loading: TopBarProgress,
});
const Owners = Loadable({
  loader: () => import("./routes/owners/active"),
  loading: TopBarProgress,
});

const Maintenance = Loadable({
  loader: () => import("./routes/vehicles/maintenance"),
  loading: TopBarProgress,
});
const Damages = Loadable({
  loader: () => import("./routes/vehicles/damages"),
  loading: TopBarProgress,
});
const Inspections = Loadable({
  loader: () => import("./routes/vehicles/inspections"),
  loading: TopBarProgress,
});

const Misuse = Loadable({
  loader: () => import("./routes/vehicles/misuse"),
  loading: TopBarProgress,
});
const Reports = Loadable({
  loader: () => import("./routes/reports"),
  loading: TopBarProgress,
});

const DriverLeads = Loadable({
  loader: () => import("./routes/leads/drivers"),
  loading: TopBarProgress,
});

const LeadsVisits = Loadable({
  loader: () => import("./routes/leads/visits"),
  loading: TopBarProgress,
});
const LeadsAnalytics = Loadable({
  loader: () => import("./routes/leads/analytics"),
  loading: TopBarProgress,
});

const ClientLeads = Loadable({
  loader: () => import("./routes/leads/clients"),
  loading: TopBarProgress,
});
const DriverPayments = Loadable({
  loader: () => import("./routes/drivers/payments"),
  loading: TopBarProgress,
});
const Tickets = Loadable({
  loader: () => import("./routes/vehicles/tickets"),
  loading: TopBarProgress,
});

const Immobilize = Loadable({
  loader: () => import("./routes/vehicles/immobilize"),
  loading: TopBarProgress,
});

const DriverPair = Loadable({
  loader: () => import("./routes/vehicles/driver-pair"),
  loading: TopBarProgress,
});

const CodDestinations = Loadable({
  loader: () => import("./routes/cod/destinations"),
  loading: TopBarProgress,
});

const CodRoutes = Loadable({
  loader: () => import("./routes/cod/routes"),
  loading: TopBarProgress,
});

const CodCutoff = Loadable({
  loader: () => import("./routes/cod/cutoff"),
  loading: TopBarProgress,
});

const LastMile = Loadable({
  loader: () => import("../lastmile/routes/routes"),
  loading: TopBarProgress,
});

const Indrive = Loadable({
  loader: () => import("./routes/indrive"),
  loading: TopBarProgress,
});

const Dash = () => (
  <Switch>
    <Route path="/map">
      <Map />
    </Route>
    <Route path="/indrive">
      <Indrive />
    </Route>
    <Route path="/lastmile">
      <LastMile />
    </Route>
    <Route path="/monitoring">
      <Monitoring />
    </Route>
    <Route path="/parcels">
      <Parcels />
    </Route>
    <Route path="/overweight">
      <OverWeight />
    </Route>
    <Route path="/drivers/active">
      <DriverActive />
    </Route>
    <Route path="/drivers/payments">
      <DriverPayments />
    </Route>
    <Route path="/drivers/references">
      <DriverReferences />
    </Route>
    <Route path="/drivers/removed">
      <DriverRemoved />
    </Route>
    <Route path="/drivers/suspension">
      <DriverSupsension />
    </Route>
    <Route path="/drivers/documents">
      <DriverDocuments />
    </Route>
    <Route path="/drivers/safety">
      <DriverSafety />
    </Route>
    <Route path="/drivers/map">
      <DriverMap />
    </Route>
    <Route path="/drivers/permissions">
      <DriverPermissions />
    </Route>
    <Route path="/vehicles/requests">
      <VehiclesRequests />
    </Route>
    <Route path="/vehicles/active">
      <VehiclesActive />
    </Route>
    <Route path="/clients">
      <Clients />
    </Route>
    <Route path="/services/history">
      <ServiceHistory />
    </Route>
    <Route path="/services/weekly">
      <ServiceWeekly />
    </Route>
    <Route path="/services/validation">
      <ServiceValidation />
    </Route>
    <Route path="/services/payments">
      <Payments />
    </Route>
    <Route path="/services/rides">
      <Rides />
    </Route>
    <Route path="/services/drivers">
      <ServiceDrivers />
    </Route>
    <Route path="/catalogs/users">
      <Users />
    </Route>
    <Route path="/catalogs/fourtrackerrors">
      <FourTrackError />
    </Route>
    <Route path="/catalogs/bindings">
      <Bindings />
    </Route>
    <Route path="/catalogs/gasoline">
      <Gasoline />
    </Route>
    <Route path="/catalogs/zones">
      <Zones />
    </Route>
    <Route path="/catalogs/alerts">
      <Alerts />
    </Route>
    <Route path="/owners/active">
      <Owners />
    </Route>
    <Route path="/catalogs/origins">
      <Origins />
    </Route>
    <Route path="/catalogs/monitor">
      <MonitorUser />
    </Route>
    <Route path="/catalogs/cordinator">
      <Cordinator />
    </Route>
    <Route path="/catalogs/lastmile">
      <Lastmile />
    </Route>
    <Route path="/vehicles/maintenance">
      <Maintenance />
    </Route>
    <Route path="/vehicles/status">
      <VehiclesStatus />
    </Route>
    <Route path="/vehicles/misuse">
      <Misuse />
    </Route>
    <Route path="/vehicles/damages">
      <Damages />
    </Route>
    <Route path="/vehicles/inspections">
      <Inspections />
    </Route>
    <Route path="/vehicles/driver-pair">
      <DriverPair />
    </Route>
    <Route path="/vehicles/tickets">
      <Tickets />
    </Route>
    <Route path="/leads/offers">
      <Offers />
    </Route>
    <Route path="/leads/requests">
      <Requests />
    </Route>
    <Route path="/leads/drivers">
      <DriverLeads />
    </Route>
    <Route path="/leads/visits">
      <LeadsVisits />
    </Route>
    <Route path="/leads/analytics">
      <LeadsAnalytics />
    </Route>
    <Route path="/leads/clients">
      <ClientLeads />
    </Route>
    <Route path="/reports">
      <Reports />
    </Route>
    <Route path="/leads/support">
      <Support />
    </Route>
    <Route path="/leads/preregister">
      <Preregister />
    </Route>
    <Route path="/vehicles/immobilize">
      <Immobilize />
    </Route>
    <Route path="/cod/destinations">
      <CodDestinations />
    </Route>
    <Route path="/cod/routes">
      <CodRoutes />
    </Route>
    <Route path="/cod/cutoff">
      <CodCutoff />
    </Route>
    <Redirect to="/map" />
  </Switch>
);

export default Dash;
